var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerConnectivityInternet4G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.8435C1.45 18.8435 0.979167 18.6477 0.5875 18.256C0.195833 17.8643 0 17.3935 0 16.8435V2.84351C0 2.29351 0.195833 1.82267 0.5875 1.43101C0.979167 1.03934 1.45 0.843506 2 0.843506H20C20.55 0.843506 21.0208 1.03934 21.4125 1.43101C21.8042 1.82267 22 2.29351 22 2.84351V16.8435C22 17.3935 21.8042 17.8643 21.4125 18.256C21.0208 18.6477 20.55 18.8435 20 18.8435H2ZM2 16.8435H20V2.84351H2V16.8435ZM19 8.84351H15.5V10.8435H17V12.8435H14V6.84351H19C19 6.29351 18.8042 5.82267 18.4125 5.43101C18.0208 5.03934 17.55 4.84351 17 4.84351H14C13.45 4.84351 12.9792 5.03934 12.5875 5.43101C12.1958 5.82267 12 6.29351 12 6.84351V12.8435C12 13.3935 12.1958 13.8643 12.5875 14.256C12.9792 14.6477 13.45 14.8435 14 14.8435H17C17.55 14.8435 18.0208 14.6477 18.4125 14.256C18.8042 13.8643 19 13.3935 19 12.8435V8.84351ZM7 14.8435H9V11.8435H11V9.84351H9V4.84351H7V9.84351H5V4.84351H3V11.8435H7V14.8435Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerConnectivityInternet4G);
export default __webpack_public_path__ + "static/media/tower_connectivity_internet_4g.9a45a9e3e485b0dde0351f4c75f57bd8.svg";
export { ForwardRef as ReactComponent };